import { render, staticRenderFns } from "./normalmsg.vue?vue&type=template&id=df2cdd4a&scoped=true"
import script from "./normalmsg.vue?vue&type=script&lang=js"
export * from "./normalmsg.vue?vue&type=script&lang=js"
import style0 from "./normalmsg.vue?vue&type=style&index=0&id=df2cdd4a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2cdd4a",
  null
  
)

export default component.exports